var _path, _g, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTickGreenCircle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "check_circle_black_24dp_1_",
    "data-name": "check_circle_black_24dp (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_17005",
    "data-name": "Path 17005",
    d: "M0,0H60V60H0Z",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_288",
    "data-name": "Ellipse 288",
    transform: "translate(6 6)",
    fill: "#40be51",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 23.5,
    fill: "none"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17006",
    "data-name": "Path 17006",
    d: "M28.26,2A26.26,26.26,0,1,0,54.52,28.26,26.27,26.27,0,0,0,28.26,2Zm0,47.268A21.008,21.008,0,1,1,49.268,28.26,21.036,21.036,0,0,1,28.26,49.268ZM40.313,16.653,23.008,33.959l-6.8-6.775-3.7,3.7,10.5,10.5L44.016,20.382Z",
    transform: "translate(1.74 1.74)",
    fill: "#40be51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickGreenCircle);
export default __webpack_public_path__ + "static/media/tick-green-circle.7fe261f913be210499b42f1887fffb3d.svg";
export { ForwardRef as ReactComponent };